import App from "./App"
import ReactDOM from 'react-dom/client';
import './index.css'
import { Toaster } from 'react-hot-toast';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
  <App/>
  <Toaster
  position="top-center"
  reverseOrder={false}
  gutter={8}
  containerClassName=""
  containerStyle={{}}

/>
  </>
);

